import { Spacing, Text } from '@vkontakte/vkui';
import React, { memo, useCallback, useEffect } from 'react';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './BeautifulAddress.css';

type BeautifulAddressDialogProps = {
    onClose?: () => void;
    onShow?: () => void;
};

const data = {
    title: 'Красивый адрес почты — в тарифах Mail Space',
    text: 'Расскажите о своём деле или просто сделайте письма заметнее. Можно придумать адрес до и после знака @. Например, ',
    primaryButtonText: 'Выбрать тариф',
    secondButtonText: 'Не сейчас',
};

export const BEAUTIFULL_ADDRESS_MODAL_ID = 'beautifulAddressModal';

export const BeautifulAddressDialog = memo<BeautifulAddressDialogProps>(({ onClose, onShow }) => {
    useEffect(() => {
        onShow?.();
        sendPaymentGa({
            eventCategory: ECategoryGa.modal,
            action: 'show',
            name: 'mnz_promo_beautiful_address_landing',
        });
        emitAnalyticEvent(AnalyticEventNames.BEAUTIFUL_ADDRESS_MODAL_SHOW);
    }, []);

    const handleClick = useCallback(() => {
        onClose?.();
    }, [onClose]);

    const handleBuy = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.modal,
            action: 'click',
            name: 'mnz_promo_beautiful_address_landing',
        });
        emitAnalyticEvent(AnalyticEventNames.BEAUTIFUL_ADDRESS_MODAL_CLICK);
        handleClick();
    }, []);

    const handleClose = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.modal,
            action: 'close',
            name: 'mnz_promo_beautiful_address_landing',
        });
        emitAnalyticEvent(AnalyticEventNames.BEAUTIFUL_ADDRESS_MODAL_CLOSE);
        handleClick();
    }, []);

    const content = (
        <>
            <Spacing size={12} />
            <Text className={styles.text}>
                {data.text}
                <span className={styles.textEmail}>pavel@sergeev.ru</span>
            </Text>
            <Spacing size={24} />
        </>
    );

    return (
        <WhatsNewDialog
            hideImage={true}
            imageUrl={''}
            showVideo={true}
            title={data.title}
            content={content}
            primaryButtonText={data.primaryButtonText}
            secondaryButtonText={data.secondButtonText}
            onClick={handleBuy}
            onSecondary={handleClose}
            buttonTheme="vk"
            dialogSize="tiny"
            isRebranding
            closable={false}
        />
    );
});

BeautifulAddressDialog.displayName = 'BeautifulAddressDialog';

export const openBeautifulAddressDialog = (data?: BeautifulAddressDialogProps) =>
    openPopupHelper({ popupName: popupNames.BEAUTIFULL_ADDRESS_DIALOG, data, onClose: data?.onClose });
